module.exports = __webpack_public_path__ + "static/media/oil-temp.fb0eca13.svg";